/**
 * ステップ統合で消えた旧カード ID の URL を、統合後のカードへ振り替える。
 *
 * 例: /format/rirekisho_hukugyo/edit/address → /format/rirekisho_hukugyo/edit/basic-info
 *
 * 広告 LP・ブログ内リンク・ブックマーク・マイページの「続きから」が持つ
 * 旧ステップ URL を 404 にしないための移行措置。`router.js` にロジックを
 * 増やさないよう、判定はここに置き、ガードからは薄く呼ぶだけにする。
 */
import { resolveCardId } from '@/utils/format-edit/cardSections'

type CardRoute = {
  name?: string | null
  params: Record<string, string>
  query?: Record<string, unknown>
  hash?: string
}

type RedirectLocation = {
  name: string
  params: Record<string, string>
  query?: Record<string, unknown>
  hash?: string
  replace: true
}

/**
 * 振り替え先が見つかればその location を返す。見つからなければ null。
 * 呼び出し側は null のとき従来どおり 404 へ落とす。
 */
export function legacyFormatCardRedirect(
  to: CardRoute
): RedirectLocation | null {
  const { formatId, cardId } = to.params
  if (!formatId || !cardId || !to.name) return null

  const resolved = resolveCardId(formatId, cardId)
  if (!resolved || resolved === cardId) return null

  return {
    name: to.name,
    params: { ...to.params, cardId: resolved },
    query: to.query,
    hash: to.hash,
    replace: true
  }
}
